import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ExternalCashTransferViewModel } from './models/external-cash-transfer-view.model';

export interface ExternalCashTransferState extends EntityState<ExternalCashTransferViewModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ExternalCashTransfer', idKey: 'UniqID' })
export class ExternalCashTransferStore extends EntityStore<ExternalCashTransferState> {

  constructor() {
    super();
  }

}
